<div class="contas-receber-container">
  <div class="card-box">
    <div class="card-cabecalho-bar">
      <div class="card-cabecalho-texto">
        <span class="card-cabecalho-titulo">{{ id > 0 ? 'Editar Conta a Receber' : 'Cadastrar Conta a Receber' }}</span>
        <span class="card-cabecalho-subtitulo">Lance valores e acompanhe os recebimentos financeiros.</span>
      </div>
      <div class="top-highlight-field">
        <label class="form-label">Previsão/Real</label>
        <select class="form-control" [(ngModel)]="previsaoReal">
          <option value="P">Previsão</option>
          <option value="R">Real</option>
        </select>
      </div>
    </div>

    <div class="row g-2 formulario-compacto">

      <!--<!--<div class="col-md-4">
        <label class="form-label">Documento *</label>
        <select class="form-control" [(ngModel)]="idFinDocumento">
          <option [ngValue]="0">Selecione</option>
          <option *ngFor="let item of documentos" [ngValue]="item.id">{{ item.descricao }}</option>
        </select>
      </div>-->
      <div class="col-md-3">
        <label class="form-label">Pago por (Cliente)</label>
        <div class="campo-com-botao">
          <app-select-busca [opcoes]="usuarios" [(ngModel)]="idUsuarioPagador"></app-select-busca>
          <button type="button" class="btn btn-outline-primary" title="Cadastrar cliente" (click)="abrirModalNovoCliente()">
            <i class="fa fa-plus"></i>
          </button>
        </div>
      </div>
     
      <div class="col-md-3">
        <label class="form-label">Centro de Custos</label>
        <select class="form-control" [(ngModel)]="idCentroCusto">
          <option [ngValue]="0">Selecione</option>
          <option *ngFor="let item of centrosCustos" [ngValue]="item.id">{{ item.descricao }}</option>
        </select>
      </div>
      <div class="col-md-3">
        <label class="form-label">Plano de Contas *</label>
        <app-select-busca [opcoes]="planosContas" [(ngModel)]="idPlanoContas"></app-select-busca>
      </div>
      <div class="col-md-2">
        <label class="form-label">Parcela</label>
        <input type="number" min="1" class="form-control" [(ngModel)]="parcela" />
      </div>
      <div class="col-md-2 col-6">
        <label class="form-label" for="pagoReceber">Pago</label>
        <div class="toggle-container">
          <label class="toggle-switch">
            <input type="checkbox" id="pagoReceber" [(ngModel)]="pago" />
            <span class="toggle-slider"></span>
          </label>
          <span class="toggle-label">{{ pago ? 'Sim' : 'Não' }}</span>
        </div>
      </div>
      <div class="col-md-2 col-6">
        <label class="form-label" for="dreReceber">DRE</label>
        <div class="toggle-container">
          <label class="toggle-switch">
            <input type="checkbox" id="dreReceber" [(ngModel)]="dre" />
            <span class="toggle-slider"></span>
          </label>
          <span class="toggle-label">{{ dre ? 'Sim' : 'Não' }}</span>
        </div>
      </div>

      <div class="col-12 section-title">Datas e recebimento</div>
      <div class="col-md-3">
        <label class="form-label">Data Emissão *</label>
        <input type="date" class="form-control" [(ngModel)]="dataEmissao" />
      </div>
      <div class="col-md-3">
        <label class="form-label">Data Vencimento</label>
        <input type="date" class="form-control" [(ngModel)]="dataVencimento" />
      </div>
      <div class="col-md-3">
        <label class="form-label">Data Recebimento</label>
        <input type="date" class="form-control" [(ngModel)]="dataRecebimento" />
        <small class="text-muted">Obrigatória se «Valor recebido» for diferente de zero.</small>
      </div>
      <div class="col-md-3">
        <label class="form-label">Tipo Recebimento</label>
        <div class="input-group">
          <select class="form-control" [(ngModel)]="idTipoRecebimento">
            <option [ngValue]="0">Selecione</option>
            <option *ngFor="let item of tiposRecebimento" [ngValue]="item.id">{{ item.descricao }}</option>
          </select>
          <button type="button" class="btn btn-outline-primary" title="Cadastrar tipo de pagamento" (click)="abrirModalTipoPagamento(modalTipoPagamento)">
            <i class="fa fa-plus"></i>
          </button>
        </div>
      </div>
      <div class="col-md-3">
        <label class="form-label">Banco</label>
        <div class="input-group">
          <select class="form-control" [(ngModel)]="banco">
            <option [ngValue]="null">Selecione</option>
            <option *ngFor="let item of bancos" [ngValue]="item.id">{{ item.descricao }}</option>
          </select>
          <button type="button" class="btn btn-outline-primary" title="Cadastrar banco" (click)="abrirModalBanco(modalBanco)">
            <i class="fa fa-plus"></i>
          </button>
        </div>
      </div>
      <div class="col-md-6">
        <label class="form-label">Pagamento vinculado</label>
        <select class="form-control" [(ngModel)]="idFinPagamento">
          <option [ngValue]="null">Selecione</option>
          <option *ngFor="let item of pagamentos" [ngValue]="item.id">{{ item.descricao }}</option>
        </select>
      </div>

      <div class="col-12 section-title">Valores</div>
      <div class="col-md-3">
        <label class="form-label">Valor documento *</label>
        <input type="number" step="0.01" class="form-control" [(ngModel)]="valorDocumento" (blur)="calcularValorRecebido()" />
      </div>
      <div class="col-md-3">
        <label class="form-label">Valor imposto</label>
        <input type="number" step="0.01" class="form-control" [(ngModel)]="valorImposto" (blur)="calcularValorRecebido()" />
      </div>
      <div class="col-md-3">
        <label class="form-label">Valor outras despesas</label>
        <input type="number" step="0.01" class="form-control" [(ngModel)]="valorOutrasDespesas" (blur)="calcularValorRecebido()" />
      </div>
      <div class="col-md-3">
        <label class="form-label">Valor desconto</label>
        <input type="number" step="0.01" class="form-control" [(ngModel)]="valorDesconto" (blur)="calcularValorRecebido()" />
      </div>
      <div class="col-md-3">
        <label class="form-label">Valor multa</label>
        <input type="number" step="0.01" class="form-control" [(ngModel)]="valorMulta" (blur)="calcularValorRecebido()" />
      </div>
      <div class="col-md-3">
        <label class="form-label">Valor custas</label>
        <input type="number" step="0.01" class="form-control" [(ngModel)]="valorCustas" (blur)="calcularValorRecebido()" />
      </div>
      <div class="col-md-3">
        <label class="form-label">Valor juros</label>
        <input type="number" step="0.01" class="form-control" [(ngModel)]="valorJuros" (blur)="calcularValorRecebido()" />
      </div>
      <div class="col-md-3">
        <label class="form-label">Valor recebido</label>
        <input type="number" step="0.01" class="form-control" [(ngModel)]="valorRecebido" />
      </div>
      <div class="col-12 valores-calcular-wrap">
        <button type="button" class="btn btn-sm btn-outline-primary valores-calcular-btn" (click)="calcularValorRecebido()">
          <i class="fa fa-calculator"></i> Calcular valor recebido
        </button>
      </div>
      <div class="d-none">
        <input type="number" step="0.0001" class="form-control" [(ngModel)]="taxaJuroSdia" />
        <input type="number" step="0.01" class="form-control" [(ngModel)]="valorCustasParcial" (blur)="calcularValorRecebido()" />
      </div>

      <div class="col-12">
        <label class="form-label">Observações</label>
        <textarea class="form-control" rows="2" [(ngModel)]="observacao"></textarea>
      </div>

      <div class="col-12 section-title" *ngIf="itensComposicao.length > 0">Itens da composição</div>
      <div class="col-12" *ngIf="itensComposicao.length > 0">
        <div class="table-responsive composicao-table-wrap">
          <table class="table table-sm table-bordered table-striped composicao-table">
            <thead>
              <tr>
                <th>Qtd</th>
                <th>Descrição</th>
                <th>Valor</th>
                <th>Plano de Contas</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of itensComposicao">
                <td>{{ item.quantidade }}</td>
                <td>{{ item.descricao }}</td>
                <td>{{ formatMoneyBRL(item.valor) }}</td>
                <td>{{ item.planoContasDescricao || '-' }}</td>
                <td class="composicao-acoes-col">
                  <button type="button" class="btn btn-sm btn-outline-primary" (click)="abrirModalEditarComposicao(item)">
                    <i class="fa fa-edit"></i> Editar
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="acoes">
      <button type="button" class="btn btn-sm btn-outline-secondary" (click)="voltar()">
        <i class="fa fa-arrow-left"></i> Voltar
      </button>
      <button type="button" class="btn btn-sm btn-success" (click)="salvar()">
        <i class="fa fa-save"></i> Salvar
      </button>
    </div>
  </div>

  <div class="composicao-modal-overlay" *ngIf="modalEditarComposicaoAberto">
    <div class="composicao-modal-box">
      <h4>Editar item da composição</h4>

      <div class="mb-3">
        <label class="form-label">Descrição</label>
        <input type="text" class="form-control" [ngModel]="itemComposicaoEdicao.descricao" [ngModelOptions]="{standalone: true}" disabled />
      </div>

      <div class="row g-3">
        <div class="col-md-4">
          <label class="form-label">Quantidade</label>
          <input type="number" min="1" class="form-control" [(ngModel)]="itemComposicaoEdicao.quantidade" [ngModelOptions]="{standalone: true}" />
        </div>
        <div class="col-md-4">
          <label class="form-label">Valor</label>
          <input type="number" min="0" step="0.01" class="form-control" [(ngModel)]="itemComposicaoEdicao.valor" [ngModelOptions]="{standalone: true}" />
        </div>
        <div class="col-md-4">
          <label class="form-label">Plano de Contas</label>
          <app-select-busca
            [opcoes]="planosContas"
            [(ngModel)]="itemComposicaoEdicao.planoContasId"
            [ngModelOptions]="{standalone: true}">
          </app-select-busca>
        </div>
      </div>

      <div class="acoes mt-3">
        <button type="button" class="btn btn-outline-secondary" (click)="fecharModalEditarComposicao()">Fechar</button>
        <button type="button" class="btn btn-success" (click)="salvarItemComposicao()">Salvar</button>
      </div>
    </div>
  </div>

  <ng-template #modalTipoPagamento let-modal>
    <div class="modal-header">
      <h5 class="modal-title">Novo Tipo de Pagamento</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
      <label class="form-label">Descrição *</label>
      <input
        type="text"
        class="form-control"
        maxlength="250"
        [(ngModel)]="novoTipoPagamentoDescricao"
        (keyup.enter)="salvarTipoPagamento(modal)"
        placeholder="Ex.: PIX, Boleto, Cartão de crédito" />
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">Cancelar</button>
      <button type="button" class="btn btn-success" (click)="salvarTipoPagamento(modal)">
        <i class="fa fa-save"></i> Salvar
      </button>
    </div>
  </ng-template>

  <ng-template #modalBanco let-modal>
    <div class="modal-header">
      <h5 class="modal-title">Novo Banco</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
      <label class="form-label">Nome do banco *</label>
      <input
        type="text"
        class="form-control"
        maxlength="100"
        [(ngModel)]="novoBancoDescricao"
        (keyup.enter)="salvarBanco(modal)"
        placeholder="Ex.: Banco Inter, Sicoob" />
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">Cancelar</button>
      <button type="button" class="btn btn-success" [disabled]="salvandoBanco" (click)="salvarBanco(modal)">
        <i class="fa fa-save"></i> Salvar
      </button>
    </div>
  </ng-template>

  <div class="novo-cliente-modal-overlay" *ngIf="modalNovoClienteAberto">
    <div class="novo-cliente-modal" role="dialog" aria-modal="true">
      <app-cadastro-cliente
        [modoModal]="true"
        [somenteAbaCliente]="true"
        (clienteSalvo)="onClienteCadastrado($event)"
        (fecharModalSolicitado)="fecharModalNovoCliente()">
      </app-cadastro-cliente>
    </div>
  </div>
</div>
